import { Divider, Grid, Typography, IconButton, Button, Paper, Tooltip } from "@mui/material";
import React, { useState } from "react";
import { WSIcons } from "../../commonFunctions/iIcons";
import { MenuList } from "./MenuList";
import Footer from "./FooterOrder";
import { ChargesInformation } from "./ChargesInformation";
import { ChooseDiscount } from "./ChooseDiscount";
import { RecipeMode } from "./ReceipieMode";

export const OrderPage: React.FC<any> = React.memo((props) => {
  const [cartOpen, setCartOpen] = useState(false);
  const [discountCartOpen, setDiscountCartOpen] = useState(false);
  const [selectedView, setSelectedView] = useState("main view");
  const [recipeMode, setRecipeMode] = useState(false);

  const handleViewChange = (view: string) => {
    setSelectedView(view);
  };
  const handleCartClick = () => {
    setCartOpen(true);
  };

  const handleCartClose = () => {
    setCartOpen(false);
  };
  const handleDiscountCartClick = () => {
    setDiscountCartOpen(true);
  };

  const handleDiscountCartClose = () => {
    setDiscountCartOpen(false);
  };
  const handleToggleRecipeMode = (checked: boolean) => {
    setRecipeMode(checked);
  };

  return (
    <Grid container direction="column" sx={{ height: '100vh' }}>
      <Grid container spacing={2} sx={{ flex: 1,  }}>
        <Grid item xs={12} sm={4} sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
          {recipeMode ? (
            <Grid sx={{ padding: '20px' }}>
              <RecipeMode />
            </Grid>
          ) : (
            <Grid sx={{ backgroundColor: '#e6e6e6', flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
              <Grid sx={{ overflowY: 'auto', padding: 1, flexGrow: 1 }}>
                {/* Item List */}
                {[{ qty: '2 glass', name: 'coffee Royal', price: '30.00' },
                  { qty: '2 glass', name: 'Irish Coffee', price: '30.00' },
                  { qty: '1 Pot', name: 'Pot Tea', price: '8.00' },
                  { qty: '1 shot', name: 'Pernod', price: '4.00' },
                  { qty: '1 shot', name: 'Montenegrone', price: '6.00' },
                  { qty: '1 shot', name: 'Recard', price: '4.00' },
                  { qty: '1 glass', name: 'Papaya Fresh Juice', price: '7.00' }]
                  .map((item, index) => (
                    <React.Fragment key={index}>
                      <Grid sx={{ padding: 1 }}>
                        <Grid container alignItems="center">
                          <Grid item xs={8} display="flex" alignItems="center">
                            <Typography variant="body1" fontWeight="bold" sx={{ mr: 2 }}>
                              {item.qty}
                            </Typography>
                            <Typography variant="body1" fontWeight="bold">
                              {item.name}
                            </Typography>
                          </Grid>
                          <Grid item xs={4} display="flex" justifyContent="flex-end">
                            <Typography variant="body1" fontWeight="bold">
                              {item.price} <WSIcons.DeleteIcon />
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Divider />
                    </React.Fragment>
                ))}
              </Grid>

              {/* Action Buttons */}
              <Grid sx={{ backgroundColor: 'white', padding: 1 }}>
                <Grid container spacing={2} justifyContent="center">
                  {[{ icon: <WSIcons.Dice />, title: "change unit" },
                    { icon: <WSIcons.FastfoodIcon />, title: "change quantity" },
                    { icon: <WSIcons.RestaurantIcon />, title: "Add modifier" },
                    { icon: <WSIcons.JuiceIcon />, title: "Preparation remark" },
                    { icon: <WSIcons.CloseIcon />, title: "Void Item" }]
                    .map((action, index) => (
                      <Grid item key={index}>
                        <Tooltip title={action.title}>
                          <IconButton>{action.icon}</IconButton>
                        </Tooltip>
                      </Grid>
                  ))}
                  <Grid item>
                    <IconButton><WSIcons.KeyboardArrowUpIcon /></IconButton>
                  </Grid>
                  <Grid item>
                    <IconButton><WSIcons.KeyboardArrowDownIcon /></IconButton>
                  </Grid>
                </Grid>
              </Grid>

              {/* Bottom Action Row */}
              <Grid container spacing={2} sx={{ padding: 1, backgroundColor: 'white' }}>
                <Grid item xs={6}>
                  <WSIcons.Tag onClick={handleCartClick} />
                  <ChargesInformation open={cartOpen} onClose={handleCartClose} />
                </Grid>
                <Grid item xs={2}>
                  <Typography color="red" variant="h6">0.00</Typography>
                </Grid>
                <Grid item xs={2}>
                  <WSIcons.DiscountIcon onClick={handleDiscountCartClick} />
                  <ChooseDiscount open={discountCartOpen} onClose={handleDiscountCartClose} />
                </Grid>
                <Grid item xs={2}>
                  <WSIcons.PaymentsIcon />
                </Grid>
              </Grid>
            </Grid>
          )}
        </Grid>

        {/* Menu and Footer */}
        <Grid item xs={12} sm={8}>
          <MenuList selectedView={selectedView} />
        </Grid>
        <Grid item xs={12}>
          <Footer onViewChange={handleViewChange} onToggleRecipeMode={handleToggleRecipeMode} />
        </Grid>
      </Grid>
    </Grid>
  );
});
